module.exports = __webpack_public_path__ + "img/logo.3cb159b2.png";